export const BORDER_RADIUS = '16px'
export const ALPHA_1 = '0.85'
export const ALPHA_2 = '0.72'
export const ALPHA_3 = '0.42'
export const ALPHA_4 = '0.25'
export const ALPHA_5 = '0.18'
export const ALPHA_CLOSE = '0.6'
export const ALPHA_DISABLED = '0.5'
export const ALPHA_DISABLED_INPUT = '0.02'
export const ALPHA_PENDING = '0.05'
export const ALPHA_TABLE_PENDING = '0.02'
export const ALPHA_PRESSED = '0.07'
export const ALPHA_AVATAR = '0.22'
export const ALPHA_RAIL = '0.15'
export const ALPHA_PROGRESS_RAIL = '0.08'
export const ALPHA_BORDER = '0.12'
export const ALPHA_DIVIDER = '0.06'
export const ALPHA_INPUT = '0'
export const ALPHA_ACTION = '0.02'
export const ALPHA_TAB = '0.04'
export const ALPHA_SCROLLBAR = '0.25'
export const ALPHA_SCROLLBAR_HOVER = '0.4'
export const ALPHA_CODE = '0.05'
export const ALPHA_TAG = '0.02'
export const ALPHA_TABLE = '0.03'

export const NORMAL_BOX_SHADOW =
  '0 16px 40px rgba(15, 23, 42, 0.08), 0 4px 12px rgba(15, 23, 42, 0.04)'

export const NORMAL_BOX_SHADOW_DARK_THEME =
  '0 18px 50px rgba(0, 0, 0, 0.2), 0 6px 18px rgba(0, 0, 0, 0.12)'

export const SPECIAL_BOX_SHADOW =
  '0 24px 80px rgba(15, 23, 42, 0.1), 0 8px 24px rgba(15, 23, 42, 0.08)'

export const SPECIAL_BOX_SHADOW_DARK_THEME =
  '0 24px 80px rgba(0, 0, 0, 0.24), 0 8px 24px rgba(0, 0, 0, 0.14)'

export const SMALL_FRONT_SIZE = '13px'

export const NORMAL_FRONT_SIZE = '16px'

export const SPECIAL_FRONT_SIZE = '24px'

export const GRAY_COLOR_1 = '#111827'

export const GRAY_COLOR_2 = '#475569'

export const GRAY_COLOR_3 = '#6b7280'

export const GRAY_COLOR_4 = '#cbd5e1'

export const GRAY_COLOR_5 = '#e2e8f0'

export const GRAY_COLOR_6 = '#f8fafc'

export const CONTENT_SPACE = '24px'

export default {
  BORDER_RADIUS,
  NORMAL_BOX_SHADOW,
  NORMAL_BOX_SHADOW_DARK_THEME,
  SPECIAL_BOX_SHADOW,
  SPECIAL_BOX_SHADOW_DARK_THEME,
  NORMAL_FRONT_SIZE,
  SPECIAL_FRONT_SIZE,
  SMALL_FRONT_SIZE,
  CONTENT_SPACE,
  GRAY_COLOR_1,
  GRAY_COLOR_2,
  GRAY_COLOR_3,
  GRAY_COLOR_4,
  GRAY_COLOR_5,
  GRAY_COLOR_6,
  ALPHA_1,
  ALPHA_2,
  ALPHA_3,
  ALPHA_4,
  ALPHA_5,
  ALPHA_ACTION,
  ALPHA_AVATAR,
  ALPHA_BORDER,
  ALPHA_CLOSE,
  ALPHA_CODE,
  ALPHA_DISABLED,
  ALPHA_DISABLED_INPUT,
  ALPHA_DIVIDER,
  ALPHA_INPUT,
  ALPHA_PENDING,
  ALPHA_PRESSED,
  ALPHA_PROGRESS_RAIL,
  ALPHA_RAIL,
  ALPHA_SCROLLBAR,
  ALPHA_SCROLLBAR_HOVER,
  ALPHA_TAB,
  ALPHA_TABLE_PENDING,
  ALPHA_TAG,
  ALPHA_TABLE,
}
